import { SVGProps } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Switch.module.scss'

interface SwitchProps {
  checked: boolean
  className?: string
  iconChecked?: React.FC<SVGProps<SVGSVGElement>>
  iconUnchecked?: React.FC<SVGProps<SVGSVGElement>>
  labelChecked: string
  labelUnchecked: string
  name: string
  onChange: (checked: boolean) => void
}

const Switch = ({
  checked,
  className,
  iconChecked: IconChecked,
  iconUnchecked: IconUnchecked,
  labelChecked,
  labelUnchecked,
  name,
  onChange,
}: SwitchProps) => (
  <div className={combineClassnames(styles.switch, className)}>
    <input
      type="checkbox"
      id={name}
      checked={checked}
      onChange={(e) => onChange(!e.target.checked)}
    />
    <label htmlFor={name}>
      <div>
        {IconUnchecked && <IconUnchecked />}
        <span>{labelUnchecked}</span>
      </div>
      <div>
        {IconChecked && <IconChecked />}
        <span>{labelChecked}</span>
      </div>
    </label>
  </div>
)

export default Switch
